var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-item"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('img',{attrs:{"src":_vm.iconImage && '/icons/icon-' + _vm.iconImage}})])}
var staticRenderFns = []

export { render, staticRenderFns }